module.exports = __webpack_public_path__ + "img/google-analytics-logo.24fddf63.jpg";